// src/core/utils/Counter.ts
var Counter = class {
  value = -1;
  up() {
    return ++this.value;
  }
};
export {
  Counter
};
//# sourceMappingURL=Counter.js.map